import { useDispatch, useSelector } from "react-redux";
import { InterventionReducerState } from "../../../interfaces/store/interventionReducerState";
import { useEffect, useState, forwardRef, useImperativeHandle } from "react";
import { useNavigate } from "react-router-dom";
import CustomTable from "../../common/ui/CustomDataGridTable";
import {
  Box,
  IconButton,
} from "@mui/material";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { GridRenderCellParams } from "@mui/x-data-grid";
import Tooltip from "@mui/material/Tooltip";
import { actionTypes } from "../../../store/actionTypes/actionTypes";
import { ADMIN } from "../../../constants/admin";
import {
  deleteDataFromApi,
  postDataFromApi,
  putDataFromApi,
} from "../../../services/api/apiService";
import { RestfulUrls } from "../../../constants/restfulUrls";
import { IApiResponse } from "../../../interfaces/common/IApiResponse";
import { COMMON } from "../../../constants/common";
import LoaderWithText from "../../common/ui/LoaderWithText";
import { UserPermission } from "../../common/UserPermission";
import { INTERVENTION_MEETING_CATEGORIES as categories} from "../../../constants/meetingConstants";

interface InterventionTableProps {
}

const InterventionTable = forwardRef<any, InterventionTableProps>(({}, ref) => {
   const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [totalCount, setTotalCount] = useState<number>(0);
  const [selectedRowData, setSelectedRowData] = useState<{ id: string } | null>(
    null
  );
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState<boolean>(false);
  const [disableDeleteSubmitBtn, setDisableDeleteSubmitBtn] = useState(false);

  const fetchIntervenlabel = useSelector(
    (state: { intervention: InterventionReducerState }) =>
      state.intervention.fetchIntervenlabel
  );

  const [rowData, setRowData] = useState<any>([]);

  const handleOrderChange = async (
    currentRow: any,
    direction: "up" | "down"
  ) => {
    const currentIndex = rowData.findIndex(
      (row: any) => row.id === currentRow.id
    );
    if (
      (direction === "up" && currentIndex === 0) ||
      (direction === "down" && currentIndex === rowData.length - 1)
    ) {
      return;
    }

    const targetIndex =
      direction === "up" ? currentIndex - 1 : currentIndex + 1;
    const targetRow = rowData[targetIndex];

    setLoading(true);
    const url = `${RestfulUrls.BASE_URL}${RestfulUrls.UPDATE_INTERVENTION_ORDER}`;
    const payloadData = {
      id1: currentRow.id,
      order1: targetRow.order,
      id2: targetRow.id,
      order2: currentRow.order,
    };

    try {
      await putDataFromApi<any>(
        url,
        payloadData,
        (response: IApiResponse<any>) => {
          console.log("Order update response:", response);
          dispatch({
            type: COMMON.SHOW_SNACKBAR,
            payload: {
              message: "Intervention Label order updated successfully.",
              severity: COMMON.SNACKBAR_SEVERITY.SUCCESS,
            },
          });
          getInterventionDetails(page, pageSize, searchTerm);
        },
        { isAuthRequired: true },
        navigate
      );
    } catch (error) {
      console.error("Error updating order:", error);
      dispatch({
        type: COMMON.SHOW_SNACKBAR,
        payload: {
          message: "Server Error.",
          severity: COMMON.SNACKBAR_SEVERITY.ERROR,
        },
      });
    } finally {
      setLoading(false);
    }
  };

  const getInterventionDetails = async (
    page: number,
    limit: number,
    search: string = ""
  ) => {
    try {
      setLoading(true);
      const url = `${RestfulUrls.BASE_URL}${RestfulUrls.PAGINATED_INTERVENTIONS}`;
      const payloadData = {
        page: page,
        limit: limit,
        search: search,
      };
      await postDataFromApi<any>(
        url,
        payloadData,
        (response: IApiResponse<any>) => {
          console.log("get INTERVENTION response data ", response);
          dispatch({
            type: actionTypes.UPDATE_INTERVENTION_TABLE_DATA,
            payload: response.data.data,
          });
          setTotalCount(response.data.pagination.total);

          setRowData(response.data.data);
        },
        { isAuthRequired: true },
        navigate
      );
    } catch (error) {
      console.error("Error fetching intervention labels:", error);
      dispatch({
        type: COMMON.SHOW_SNACKBAR,
        payload: {
          message: "Error fetching intervention labels.",
          severity: COMMON.SNACKBAR_SEVERITY.ERROR,
        },
      });
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (newPage: number) => {
    setPage(newPage);
    getInterventionDetails(newPage, pageSize, searchTerm);
  };

  const handlePageSizeChange = (newPageSize: number) => {
    setPageSize(newPageSize);
  };

  const handleAddButtonClick = () => {
    dispatch({
      type: actionTypes.SELECTED_INTERVENTION_TABLE_ROW,
      payload: null,
    });
    dispatch({
      type: actionTypes.OPEN_INTERVENTION_FORM,
      payload: true,
    });
    dispatch({
      type: actionTypes.UPDATE_FETCH_INTERVENTION_LABEL,
      payload: false,
    });
  };



  const onEditIconClick = (selectedRow: any) => {
    dispatch({
      type: actionTypes.OPEN_INTERVENTION_FORM,
      payload: true,
    });
    dispatch({
      type: actionTypes.SELECTED_INTERVENTION_TABLE_ROW,
      payload: selectedRow,
    });
    dispatch({
      type: actionTypes.UPDATE_INTERVENTION_FORM_TYPE,
      payload: ADMIN.MEETING_FORM_TYPE.EDIT,
    });
    dispatch({
      type: actionTypes.UPDATE_FETCH_INTERVENTION_LABEL,
      payload: false,
    });
  };
  const dummyModalCloseTw = () => {};

  const handleDeleteIntgerventionLabel = async () => {
    setDisableDeleteSubmitBtn(true);
    const url = `${RestfulUrls.BASE_URL}${RestfulUrls.DELETE_INTERVENTION_LABEL}/${selectedRowData?.id}`;
    await deleteDataFromApi<any>(
      url,
      null,
      () => {
        dispatch({
          type: COMMON.SHOW_SNACKBAR,
          payload: {
            message: "Intervention label deleted successfully.",
            severity: COMMON.SNACKBAR_SEVERITY.SUCCESS,
          },
        });
        getInterventionDetails(page, pageSize, searchTerm);
        setIsDeleteModalOpen(false);
        setDisableDeleteSubmitBtn(false);
       
      },
      { isAuthRequired: true },
      navigate
    );
    setDisableDeleteSubmitBtn(false);
  };

  const onSelectedDeleteIconClick = (selectedRow: any) => {
    setIsDeleteModalOpen(true);
    setSelectedRowData(selectedRow);
  };
  const handleCloseDeleteModal = () => {
    setIsDeleteModalOpen(false);
    setSelectedRowData(null);
  };

  const tableHeader = [
    {
      field: "id",
      headerName: <div className='fw-700'>ID</div>,
      width: 50,
      sortable: false,
    },
    {
      field: "label",
      headerName: <div className='fw-700'>Label</div>,
      flex: 1.2,
      minWidth: 200,
    },
    {
      field: "category",
      headerName: <div className='fw-700'>Category</div>,
      flex: 0.9,
      minWidth: 150,
      renderCell: (params: any) => (
        categories[params.value as keyof typeof categories] || "-"
      ),
    },
    {
      field: "isActive",
      headerName: <div className='fw-700'>Status</div>,
      flex: 0.6,
      minWidth: 100,
      renderCell: (params: GridRenderCellParams) => {
        return (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              fontWeight: "medium",
            }}
          >
            {params.value ? "Active" : "Inactive"}
          </Box>
        );
      },
    },
    {
      field: "order",
      headerName: <div className='fw-700'>Reorder</div>,
      flex: 0.7,
      minWidth: 120,
      resizable: false,
      renderCell: (params: GridRenderCellParams) => {
        return (
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            {/*  <span>{params.value}</span> */}
            <Box>
              <IconButton
                size='small'
                onClick={() => handleOrderChange(params.row, "up")}
                disabled={params.row.order === 1 || loading}
              >
                <KeyboardArrowUpIcon />
              </IconButton>
              <IconButton
                size='small'
                onClick={() => handleOrderChange(params.row, "down")}
                disabled={params.row.order === rowData.length || loading}
              >
                <KeyboardArrowDownIcon />
              </IconButton>
            </Box>
          </Box>
        );
      },
    },

    {
      field: "actions",
      headerName: <div className='fw-700'>Actions</div>,
      flex: 0.6,
      minWidth: 100,
      resizable: false,
      renderCell: (params: GridRenderCellParams) => {
        return (
          <Box sx={{ display: "flex", gap: 1 }}>
            <Tooltip title='Edit Intervention'>
              <IconButton
                size='small'
                onClick={() => {
                  onEditIconClick(params.row);
                  }}
              >
                <EditOutlinedIcon className='de-icon' />
              </IconButton>
            </Tooltip>
            <Tooltip title='Delete Intervention'>
              <IconButton
                size='small'
                onClick={() => onSelectedDeleteIconClick(params.row)}
              >
                <DeleteOutlineOutlinedIcon className='de-icon' />
              </IconButton>
            </Tooltip>
          </Box>
        );
      },
    },
  ];

  useEffect(() => {
      getInterventionDetails(page, pageSize, searchTerm);
  }, [page, pageSize]);

  useEffect(() => {
    if (fetchIntervenlabel) {
      getInterventionDetails(page, pageSize, searchTerm);
    }
  }, [fetchIntervenlabel]);

  useImperativeHandle(ref, () => ({
    performSearch: (query: string) => {
      setSearchTerm(query);
      setPage(1);
      getInterventionDetails(1, pageSize, query);
    },
    performCreate: () => {
      handleAddButtonClick();
    },
  }));

  return (
    <>
      <Box className='intervention-table'>
        <CustomTable
          columns={tableHeader}
          rows={rowData}
          hideFooter={false}
          disableColumnFilter={false}
          checkboxSelection={false}
          disableColumnSelector={true}
          disableDensitySelector={true}
          className='extraction_datatable'
          showToolbar={false}
          paginationMode='server'
          pageSize={pageSize}
          page={page - 1} // MUI DataGrid uses 0-based pagination
          rowCount={totalCount}
          onPageChange={(newPage) => handlePageChange(newPage + 1)}
          onPageSizeChange={handlePageSizeChange}
          rowsPerPageOptions={[5, 10, 25, 50]}
          disableColumnSorting={true}
        />
      </Box>
      <LoaderWithText isOpen={loading} onClose={dummyModalCloseTw} />
      <UserPermission
        isModalOpen={isDeleteModalOpen}
        titleOne={"Are you sure"}
        title={"you want to delete selected item?"}
        disableSubmitBtn={disableDeleteSubmitBtn}
        onConfirmedButtonClick={handleDeleteIntgerventionLabel}
        onCancelButtonClick={handleCloseDeleteModal}
        onCloseModal={handleCloseDeleteModal}
      />
    </>
  );
});

InterventionTable.displayName = "InterventionTable";

export default InterventionTable;
